
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import i18n from '@/i18n';
import OrderMailLogs from './OrderMailLogs.vue';
import { GQL_order_order } from '@/queries/__generated__/order';
import { GET_CUSTOMER } from '@/queries/Customer';
import MailButton from '../../Shared/MailButton.vue';
import { emailRecipients } from '@/app/Invoice';
import gql from 'graphql-tag';

const EMAIL_ORDER = gql`
  mutation emailOrder($orderId: ID!, $pdfType: OrderPDFTypeEnum!, $recipients: [String!]!) {
    emailOrder(
      input: {
        orderId: $orderId,
        pdfType: $pdfType,
        recipients: $recipients,
      }
    ) {
      logOrderMails {
        id pdfType recipientMail sentAt
        sentBy { id name }
        deliveryStatus
        deliveryError
      }
    }
  },
`;

@Component({
  components: {
    OrderMailLogs,
    MailButton,
  },
})

export default class OrderMailButton extends Vue {
  @Prop({ type: Object, required: true }) order!: GQL_order_order;
  @Prop({ type: Boolean, default: false }) addCompanyMailToCC!: boolean;
  @Prop({ type: String, required: true }) private pdfType!: string;

  @Prop({ type: Object, required: true }) private logsQuery!: object;
  @Prop({ type: Object }) private logsVariables!: object;
  @Prop({ type: Function, required: true }) private logsUpdate!: object;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;

  private EMAIL_ORDER = EMAIL_ORDER

   private recipient: string | null = "";
   private copies: string[] = [];

  private mounted() {
    this.resetRecipients(null);
  }

  public loadCustomer() {
    this.$apollo.query({
      query: GET_CUSTOMER,
      variables: { id: this.order.customer.id },
    }).then(({data}) => {
      this.resetRecipients(data.customer.email);
    });
  }


  private resetRecipients(customerMail: string | null) {
   [ this.recipient, this.copies ] = emailRecipients(
      customerMail || false,
      this.addCompanyMailToCC,
      this.order.supplierParty.email || false,
    );
  }

  private onSent() {
    this.$sMessage.success(i18n.t('Document.Email.sendSuccess'));
    this.resetRecipients(null);
  }
}
